/* Wishlist count for the header heart.
 *
 * Mirrors what cart-count does for the cart: a small badge that says how many
 * things are waiting, so the icon is worth looking at rather than being one
 * more piece of chrome. The number comes from Swym, which is the only thing
 * that knows it — Liquid cannot, because a wishlist belongs to the visitor and
 * not to the page.
 *
 * Deliberately quiet: if Swym never loads, or the fetch fails, or the list is
 * empty, the badge stays hidden and the heart is still a working link to the
 * wishlist page. Nothing here is allowed to throw into the header.
 */
(function () {
  'use strict';
  if (window.__willowWishlistCount) return;
  window.__willowWishlistCount = true;

  function badges() {
    return document.querySelectorAll('[data-wv-wishlist-count]');
  }

  function render(count) {
    var n = typeof count === 'number' && isFinite(count) ? Math.max(0, Math.floor(count)) : 0;
    badges().forEach(function (badge) {
      badge.textContent = n > 99 ? '99+' : String(n);
      badge.hidden = n === 0;
    });
  }

  function readCount(swat) {
    // Swym has carried more than one shape for this over the years, so ask for
    // the list and count it rather than trusting a convenience property that
    // may not be there. Two shapes are live: an array of LISTS, each holding
    // its saved products in `listcontents`, and — as on this store — a flat
    // array of the saved products themselves. Counting only the first left the
    // badge permanently hidden however much was saved.
    try {
      swat.fetch(
        function (payload) {
          if (!Array.isArray(payload)) return;
          var total = payload.reduce(function (sum, entry) {
            if (!entry) return sum;
            if (Array.isArray(entry.listcontents)) return sum + entry.listcontents.length;
            return sum + (entry.empi || entry.du ? 1 : 0);
          }, 0);
          render(total);
        },
        function () {}
      );
    }
    catch (error) {
      /* leave the badge hidden */
    }
  }

  function init(swat) {
    if (!swat || typeof swat.fetch !== 'function') return;
    readCount(swat);

    // Re-read whenever the list changes, so saving from a product page updates
    // the header without a reload.
    if (swat.evtLayer && swat.JSEvents) {
      ['addedToWishlist', 'removedFromWishlist'].forEach(function (name) {
        var type = swat.JSEvents[name];
        if (!type) return;
        swat.evtLayer.addEventListener(type, function () { readCount(swat); });
      });
    }
  }

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(init);
  if (window._swat) init(window._swat);
})();
